module.exports = __webpack_public_path__ + "static/media/desktop_separator_06.beddb8c1.webp";